import { FieldWrapper, FormTextField } from "styles/formStyleComponents";
import InfoIconWithTooltip from "./InfoIconWithTooltip";

const NumberFieldComponent = ({
  name,
  label,
  placeholder,
  value,
  required,
  disabled,
  error,
  info,
  validation = {},
  onChange,
}) => {
  const fieldLabel = required ? `${label}` : label;
  const pattern = validation.pattern || /^\d+$/;  
  const maxLength = validation.maxLength;
  const min = validation.min;
  const max = validation.max;

  const handleNumberChange = (e) => {
    const val = e.target.value;
    
    if (val === "") {
      onChange(name, val);
      return;
    }
    
    if (pattern && !pattern.test(val)) {
      return; 
    }
    
    if (val.length > maxLength) {
      return; 
    }
    
    const numVal = parseFloat(val);
    if (min !== undefined && numVal < min) {
      return;
    }
    if (max !== undefined && numVal > max) {
      return;
    }
    
    onChange(name, val);
  };

  return (
    <FieldWrapper>
      <FormTextField
        label={fieldLabel}
        variant="outlined"
        size="small"
        fullWidth
        required={required}
        disabled={disabled}
        placeholder={placeholder}
        value={value || ""}
        onChange={handleNumberChange}
        type="text"
        error={!!error}
        helperText={error}
        slotProps={{
          input: {
            inputMode: 'numeric',
            pattern: '[0-9]*',
            maxLength: maxLength,
          },
        }}
        InputProps={{
          endAdornment: <InfoIconWithTooltip info={info} />,
        }}
      />
    </FieldWrapper>
  );
};

export default NumberFieldComponent;

